import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)
import New from './views/new.vue'
import SearchAges from './components/search/ages.vue'
import SearchCoverage from './components/search/coverage.vue'
import SearchCreating from './components/search/creating.vue'
import SearchIntro from './components/search/intro.vue'
import SearchLocation from './components/search/location.vue'
import SearchShow from './views/show.vue'
import SearchStart from './components/search/start.vue'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      children: [
        { name: "Search", path: '', component: SearchStart, meta: { step: 1, title: "New Search" } },
        { name: "SearchStep2", path: 'intro', component: SearchIntro, meta: { step: 2, title: "New Search" } },
        { name: "SearchStep3", path: 'coverage', component: SearchCoverage, meta: { step: 3, title: "New Search" } },
        { name: "SearchStep4", path: 'ages', component: SearchAges, meta: { step: 4, title: "New Search" } },
        { name: "SearchStep5", path: 'location', component: SearchLocation, meta: { step: 5, title: "New Search" } },
        { name: "SearchStep6", path: 'creating', component: SearchCreating, meta: { step: 6, title: "New Search" } },
      ],
      meta: { depth: 7, title: "New Search" },
      path: '/',
      component: New
    },

    {
      name: "SearchShow",
      meta: { depth: 8, title: "Search Results" },
      path: '/results/:searchId',
      component: SearchShow
    }
  ]
})

import store from './store'
import firebase from 'firebase'

router.afterEach(function(to) {
  window.document.title = (to.meta.title || "Find great childcare")
})

router.beforeEach((to, from, next) => {
  if (!firebase.auth().currentUser) {
    firebase.auth().onAuthStateChanged(function(user) {
      store.commit('setUser', user)
      store.commit('setIsAuthenticated', true)
      next()
    })
    firebase.auth().signInAnonymously()
  } else {
    next()
  }
})

export default router;
